module.exports = __webpack_public_path__ + "static/img/110120.75317f77.png";